jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

		const productInfo = document.querySelectorAll(".t4s-product-info__wrapper");
		let maxHeight = 0;

		productInfo.forEach(function(product) {
			const height = product.offsetHeight;
			product.dataset("height", height);
			if (height > maxHeight) {
				maxHeight = height;
			}
		});

		productInfo.forEach(function(product) {
			product.style.height = `${maxHeight}px`;
		});

});


